import React, { useState } from 'react'
import { SkeletonList } from '../../components/Skeleton'
import {
  BackLink,
  ContentMaxWidth,
  GhostButton,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  Row,
  Stack,
} from '../../layout/styledComponents'
import { useSessionsList } from '../../hooks/useSessions'
import { usePatient } from '../../context/PatientContext'
import * as sessions from '../../services/sessionsService'
import SessionCard from './components/SessionCard'
import RescheduleDialog from './components/RescheduleDialog'
import CancelDialog from './components/CancelDialog'
import RequestSessionDialog from './components/RequestSessionDialog'

export default function UpcomingSessionsPage() {
  const { currentProfile } = usePatient()
  const { data, loading, refresh } = useSessionsList('upcoming')
  const [reschedTarget, setReschedTarget] = useState(null)
  const [cancelTarget, setCancelTarget] = useState(null)
  const [requestOpen, setRequestOpen] = useState(false)

  async function doReschedule(body) {
    if (!reschedTarget) return
    await sessions.reschedule(currentProfile, reschedTarget.eventId, body)
    refresh()
  }
  async function doCancel(body) {
    if (!cancelTarget) return
    await sessions.cancel(currentProfile, cancelTarget.eventId, body)
    refresh()
  }
  async function doRequest(body) {
    await sessions.requestSession(currentProfile, body)
    refresh()
  }

  return (
    <ContentMaxWidth>
      <Stack $gap="20px">
        <BackLink to="/patient-home/sessions">Back to Sessions</BackLink>
        <Row $between $wrap>
          <div>
            <Pill>Sessions</Pill>
            <PageHeading style={{ marginTop: 12 }}>Upcoming sessions</PageHeading>
            <PageSubheading>Join, reschedule, or cancel.</PageSubheading>
          </div>
          <GhostButton onClick={() => setRequestOpen(true)}>+ Request session</GhostButton>
        </Row>

        {loading && !data ? (
          <SkeletonList count={3} />
        ) : !data?.items?.length ? (
          <div
            style={{
              padding: '48px 24px',
              textAlign: 'center',
              border: '1px dashed rgba(31,41,55,0.18)',
              borderRadius: 20,
            }}
          >
            <p style={{ fontSize: 18, marginTop: 0, marginBottom: 8 }}>No upcoming sessions.</p>
            <Muted>Request one from a practitioner you&apos;ve seen — or from your therapist&apos;s page.</Muted>
          </div>
        ) : (
          <Stack $gap="12px">
            {data.items.map((s) => (
              <SessionCard
                key={s.eventId}
                session={s}
                variant="upcoming"
                onReschedule={(sess) => setReschedTarget(sess)}
                onCancel={(sess) => setCancelTarget(sess)}
              />
            ))}
          </Stack>
        )}
      </Stack>

      <RescheduleDialog
        open={!!reschedTarget}
        session={reschedTarget}
        onClose={() => setReschedTarget(null)}
        onSubmit={doReschedule}
      />
      <CancelDialog
        open={!!cancelTarget}
        session={cancelTarget}
        onClose={() => setCancelTarget(null)}
        onSubmit={doCancel}
      />
      <RequestSessionDialog
        open={requestOpen}
        onClose={() => setRequestOpen(false)}
        onSubmit={doRequest}
      />
    </ContentMaxWidth>
  )
}
